export default __webpack_public_path__ + "static/media/skull pun logo.1ded2080.png";